import { Routes } from '@angular/router';
import { PageResolverService } from './service/page-resolver.service';
import { DynamicPageLoaderComponent } from './shared/dynamic-page-loader/dynamic-page-loader.component';
var ɵ0 = PageResolverService;
export var route = [
    { path: "**", component: DynamicPageLoaderComponent, resolve: { data: ɵ0 } },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0 };
